<template>

  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Fundraising</h1>
    </div>
    <div v-show="progress.stage_seven === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">Data Request</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Prior to our first call please fill out this questionnaire</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Click on the save draft button to save your progress</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">10mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="contain">
              <!-- <div v-show="windowWidth > 768" class="progress-bar relative">
                <div class="line w-[87%] bg-lineGray h-[2px] absolute mx-3 left-7 top-[7.5px]"></div>
                <div class="step flex flex-col items-center">
                  <div class="bullet active">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Fundraising</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Team</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Exit</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Schedule Meeting time</p>
                </div>
              </div> -->
              <div class="progress relative bg-faintGrey rounded-[4px] py-3 px-4 mb-8">
                <div class="current-progress relative flex items-center justify-between active">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Fundraising
                  </div>
                  <div class="max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="text-black">1</span> of 4
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Team
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">2</span> of 4
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Exit
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">3</span> of 4
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Schedule Meeting time
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">4</span> of 4
                  </div>
                </div>
              </div>
              <div>
                <div class="form-outer">
                  <div class="forms">
                    <div class="page slide-page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="target-raise "
                        >
                          <span class="text-red-400">*</span>
                          To confirm, what is the target raise in this round? In other words, how much is being raised in this round? And at what pre-money valuation?
                        </label>
                        <textarea
                          id="target-raise "
                          name="target-raise "
                          type="text"
                          rows="3"
                          :class="[
                          v$.target_raise.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Eg. We aim to raise a total of $__ in this round. So far, we have raised $__ cumulatively"
                          style="transition: 'all .15s ease'"
                          v-model="v$.target_raise.$model"
                          @blur="v$.target_raise.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.target_raise.length} of 400`}}</span>
                        <div v-if="v$.target_raise.$error">
                          <p
                            v-if="v$.target_raise.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Target raise is required</p>
                          <p
                            v-if="v$.target_raise.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Target raise should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="prior-rounds"
                        >
                          <span class="text-red-400">*</span>
                          If prior rounds of funding have occurred, please provide details (amount raised, valuation, close date) as well as objectives of each round and key results.
                        </label>
                        <textarea
                          id="prior-rounds"
                          name="prior-rounds"
                          type="text"
                          rows="3"
                          :class="[
                          v$.prior_raise.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Provide amount raised, valuation, funding close date as well as objectives of each round and key results."
                          style="transition: 'all .15s ease'"
                          v-model="v$.prior_raise.$model"
                          @blur="v$.prior_raise.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.prior_raise.length} of 400`}}</span>
                        <div v-if="v$.prior_raise.$error">
                          <p
                            v-if="v$.prior_raise.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Prior rounds is required</p>
                          <p
                            v-if="v$.prior_raise.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Prior rounds should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">Does your firm have any debt?</label>
                        <fieldset class="mt-4">
                          <label class="sr-only font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                            <span class="text-red-400">*</span>
                            Does your firm have any debt?</label>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center md:ml-2 ml-0">
                              <input id="yes" name="debts" type="radio" checked value="Yes" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.existing_debt">
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>
                            <div class="flex items-center">
                              <input id="no" name="debts" type="radio" value="No" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.existing_debt">
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="relative w-full mb-6">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">Are existing investors participating in this round of funding?</label>
                        <fieldset class="mt-4">
                          <legend class="sr-only">
                            <span class="text-red-400">*</span>
                            Are existing investors participating in this round of funding?</legend>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center md:ml-2 ml-0">
                              <input id="yes" name="existing-investors" type="radio" checked value="Yes" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.existing_investors">
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>
                            <div class="flex items-center">
                              <input id="no" name="existing-investors" type="radio" value="No" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.existing_investors">
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="fund-use"
                        >
                          <span class="text-red-400">*</span>
                          What is the planned use of funds for this funding round?
                        </label>
                        <div v-for="(use, index) in data.cash_use" :key="index" class="relative">
                          <span v-if="index > 0" @click="removeField(data.cash_use, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="fund-use"
                            name="fund-use"
                            type="text"
                            :class="[
                            (v$.cash_use.$each.$response.$data[index].data.$error && v$.cash_use.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="25% for sales and marketing"
                            style="transition: 'all .15s ease'"
                            v-model="v$.cash_use.$model[index].data"
                            @blur="v$.cash_use.$touch()"
                          />
                          <!-- {{v$.cash_use.$each.$response.$data[index]}} -->
                          <div v-if="v$.cash_use.$each.$response.$data[index].data.$error && v$.cash_use.$dirty">
                            <p
                              v-if="!v$.cash_use.$each.$response.$data[index].data.required && v$.cash_use.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Cash use is required</p>
                          <p
                            v-if="!v$.cash_use.$each.$response.$data[index].data.minLengthValue"
                            class="text-red-400 text-[10px] font-light"
                          >Cash use should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addNewField(data.cash_use)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="financing-milestones"
                        >
                          <span class="text-red-400">*</span>
                          What milestones will this financing allow you to reach?
                        </label>
                        <div v-for="(milestone, index) in data.milestones" :key="index" class="relative">
                          <span v-if="index > 0" @click="removeField(data.milestones, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>

                          <input
                            id="financing-milestones"
                            name="financing-milestones"
                            type="text"
                            :class="[
                            (v$.milestones.$each.$response.$data[index].data.$error && v$.milestones.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="Acquire 100,000 new users by January 2022"
                            style="transition: 'all .15s ease'"
                            v-model="v$.milestones.$model[index].data"
                            @blur="v$.milestones.$touch()"
                          />
                          <div v-if="v$.milestones.$each.$response.$data[index].data.$error && v$.milestones.$dirty">
                            <p
                              v-if="!v$.milestones.$each.$response.$data[index].data.required && v$.milestones.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Financing milestone is required</p>
                            <p
                              v-if="!v$.milestones.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Financing milestone should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addNewField(data.milestones)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="future-rounds"
                        >
                          <span class="text-red-400">*</span>
                          Do you anticipate future rounds of funding? If so, please describe when and why?
                        </label>
                        <textarea
                          id="future-rounds"
                          name="future-rounds"
                          type="text"
                          rows="3"
                          :class="[
                          v$.future_funding.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Tell us if you anticipate funding rounds in the future."
                          style="transition: 'all .15s ease'"
                          v-model="v$.future_funding.$model"
                          @blur="v$.future_funding.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.future_funding.length} of 400`}}</span>
                        <div v-if="v$.future_funding.$error">
                          <p
                            v-if="v$.future_funding.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Future rounds is required</p>
                          <p
                            v-if="v$.future_funding.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Future rounds should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-10">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="closing-date"
                        >
                          <span class="text-red-400">*</span>
                          What is the anticipated fundraising close date for this current round? (Must be a future date)
                        </label>
                        <input
                          id="closing-date"
                          name="closing-date"
                          type="date"
                          :class="[
                          v$.fundraise_close.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          style="transition: 'all .15s ease'"
                          v-model="v$.fundraise_close.$model"
                          @blur="v$.fundraise_close.$touch()"
                        />
                        <div v-if="v$.fundraise_close.$error">
                          <p
                            v-if="v$.fundraise_close.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Your fundraising close date is required</p>
                        </div>
                      </div>
                      <div class="relative flex md:justify-end justify-between w-full mb-6">
                        <button
                          class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
                          @click="onSaveDraft"
                        >
                          Save draft
                        </button>
                        <button :disabled="checkValidForm(v$, 'Fundraising')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50" @click="goToStep2">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="scale-team"
                        >
                          <span class="text-red-400">*</span>
                          What key additions are needed in the short term? In other words, How do you plan to scale the team in the next 12 months?
                        </label>
                        <textarea
                          id="scale-team"
                          name="scale-team"
                          type="text"
                          rows="3"
                          :class="[
                          v$.shortterm_needs.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Tell us how you plan to scale the team and product within the next 12 months"
                          style="transition: 'all .15s ease'"
                          v-model="v$.shortterm_needs.$model"
                          @blur="v$.shortterm_needs.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.shortterm_needs.length} of 400`}}</span>
                        <div v-if="v$.shortterm_needs.$error">
                          <p
                            v-if="v$.shortterm_needs.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Key team additions is required</p>
                          <p
                            v-if="v$.shortterm_needs.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Key team should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">Are vesting provisions in place for those members that hold stock?</label>
                        <fieldset class="mt-4">
                          <legend class="sr-only">Are vesting provisions in place for those members that hold stock?</legend>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center md:ml-2 ml-0">
                              <input id="yes" name="member-stock" type="radio" value="Yes" v-model="v$.vesting_provisions.$model" checked class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>
                            <div class="flex items-center">
                              <input id="no" name="member-stock" type="radio" value="No" v-model="v$.vesting_provisions.$model" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <label
                        class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                      >
                        How many employees does the company have? Please identify the number of full-time and part time employees.
                      </label>
                      <div class="relative flex md:flex-row flex-col w-full mb-6 mt-2">
                        <div class="md:mr-2 m-0 mb-2 w-full">
                          <label
                            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                            for="full-time"
                          >
                            <span class="text-red-400">*</span>
                            FULL TIME
                          </label>
                          <input
                            id="full-time"
                            name="full-time"
                            type="number"
                          :class="[
                          v$.fulltime_employee.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="22"
                            style="transition: 'all .15s ease'"
                          v-model="v$.fulltime_employee.$model"
                          @blur="v$.fulltime_employee.$touch()"
                          />
                        <div v-if="v$.fulltime_employee.$error">
                          <p
                            v-if="v$.fulltime_employee.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Full-time employees is required</p>
                          <p
                            v-if="v$.fulltime_employee.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.fulltime_employee.minValueValue.$message}}</p>
                        </div>
                        </div>
                        <div class="md:mr-2 m-0 mb-2 w-full">
                          <label
                            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                            for="part-time"
                          >
                            <span class="text-red-400">*</span>
                            PART TIME
                          </label>
                          <input
                            id="part-time"
                            name="part-time"
                            type="number"
                          :class="[
                          v$.parttime_employee.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="12"
                            style="transition: 'all .15s ease'"
                          v-model="v$.parttime_employee.$model"
                          @blur="v$.parttime_employee.$touch()"
                          />
                        <div v-if="v$.parttime_employee.$error">
                          <p
                            v-if="v$.parttime_employee.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Part-time employees is required</p>
                          <p
                            v-if="v$.parttime_employee.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.parttime_employee.minValueValue.$message}}</p>
                        </div>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">Are key members under an employment agreement?</label>
                        <fieldset class="mt-4">
                          <legend class="sr-only">Are key members under an employment agreement?</legend>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center md:ml-2 ml-0">
                              <input id="yes" name="employed-members" type="radio" value="Yes" v-model="data.employee_agreement" checked class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>

                            <div class="flex items-center">
                              <input id="no" name="employed-members" type="radio" value="No" v-model="data.employee_agreement" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="relative w-full mb-10">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="potential-conflicts"
                        >
                          <span class="text-red-400">*</span>
                          State any potential conflicts of interest that founders and key team members might have?
                        </label>
                        <textarea
                          id="potential-conflicts"
                          name="potential-conflicts"
                          type="text"
                          rows="3"
                          :class="[
                          v$.intrest_conflict.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Tell us about potential conflicts of interest founders and key team members might have"
                          style="transition: 'all .15s ease'"
                          v-model="v$.intrest_conflict.$model"
                          @blur="v$.intrest_conflict.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.intrest_conflict.length} of 400`}}</span>
                        <div v-if="v$.intrest_conflict.$error">
                          <p
                            v-if="v$.intrest_conflict.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Potential conflicts of interest is required</p>
                          <p
                            v-if="v$.intrest_conflict.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Potential conflicts should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep1">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Team')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep1">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center md:bg-[transparent] bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Team')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="likely-exit"
                        >
                          <span class="text-red-400">*</span>
                          What is the likely exit?
                        </label>
                        <textarea
                          id="likely-exit"
                          name="likely-exit"
                          type="text"
                          rows="3"
                          :class="[
                          v$.likely_exit.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder=""
                          style="transition: 'all .15s ease'"
                          v-model="v$.likely_exit.$model"
                          @blur="v$.likely_exit.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.likely_exit.length} of 400`}}</span>
                        <div v-if="v$.likely_exit.$error">
                          <p
                            v-if="v$.likely_exit.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Likely exit is required</p>
                          <p
                            v-if="v$.likely_exit.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Likely exit should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="likely-acquirers"
                        >
                          <span class="text-red-400">*</span>
                          If M&A, then who are likely acquirers?
                        </label>
                        <textarea
                          id="likely-acquirers"
                          name="likely-acquirers"
                          type="text"
                          rows="3"
                          :class="[
                          v$.likely_acquirers.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder=""
                          style="transition: 'all .15s ease'"
                          v-model="v$.likely_acquirers.$model"
                          @blur="v$.likely_acquirers.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.likely_acquirers.length} of 400`}}</span>
                        <div v-if="v$.likely_acquirers.$error">
                          <p
                            v-if="v$.likely_acquirers.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Likely acquirers is required</p>
                          <p
                            v-if="v$.likely_acquirers.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Likely acquirers should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="likely-time"
                        >
                          <span class="text-red-400">*</span>
                          When do you see an exit happening?
                        </label>
                        <textarea
                          id="likely-time"
                          name="likely-time"
                          type="text"
                          rows="3"
                          :class="[
                          v$.likely_time.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder=""
                          style="transition: 'all .15s ease'"
                          v-model="v$.likely_time.$model"
                          @blur="v$.likely_time.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.likely_time.length} of 400`}}</span>
                        <div v-if="v$.likely_time.$error">
                          <p
                            v-if="v$.likely_time.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >When do you see an exit happening is required</p>
                          <p
                            v-if="v$.likely_time.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >When do you see an exit should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-10">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="exit-valuation"
                        >
                          <span class="text-red-400">*</span>
                          How will an exit valuation be determined?
                        </label>
                        <textarea
                          id="exit-valuation"
                          name="exit-valuation"
                          type="text"
                          rows="3"
                          :class="[
                          v$.exit_valuation.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder=""
                          style="transition: 'all .15s ease'"
                          v-model="v$.exit_valuation.$model"
                          @blur="v$.exit_valuation.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.exit_valuation.length} of 400`}}</span>
                        <div v-if="v$.exit_valuation.$error">
                          <p
                            v-if="v$.exit_valuation.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Exit valuation is required</p>
                          <p
                            v-if="v$.exit_valuation.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Exit valuation should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep2">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Exit')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep4">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep2">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center md:bg-[transparent] bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Exit')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep4">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="meetingTime"
                        >
                          <span class="text-red-400">*</span>
                          Schedule time to speak with the Kinfolk team
                        </label>
                        <div class="mt-4 mb-2 flex items-center">
                          <Switch
                            v-model="enabled"
                            :disabled="calenderLoaded"
                            :class="enabled ? 'bg-black' : 'bg-lineGray'"
                            class="relative inline-flex flex-shrink-0 h-[31px] w-[51px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                          >
                            <span class="sr-only">Schedule meeting time</span>
                            <span
                              aria-hidden="true"
                              :class="enabled ? 'translate-x-5' : 'translate-x-0'"
                              class="pointer-events-none inline-block h-[27px] w-[27px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                            />
                          </Switch>
                          <p class="ml-4 text-black font-Rubik text-[15px] leading-[17.78px]">Schedule meeting time</p>
                        </div>
                        <svg v-if="enabled && !calenderLoaded" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="35px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                          <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                          </circle>
                        </svg>
                        <div id="calender" class="h-[600px] mt-1"></div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="bg-coolGray-100 text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep3">
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="!schedule_meeting" @click="onSubmit" class="bg-black text-white rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                            <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                            <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                              <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                              </circle>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep3">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button
                          :disabled="!schedule_meeting"
                          @click="onSubmit"
                          class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50"
                        >
                          <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                          <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                            </circle>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
    <div v-show="progress.stage_seven === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_seven ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { Switch } from '@headlessui/vue'
import industries from '@/utils/industries'
import businessmodel from '@/utils/businessmodels'
import fundinground from '@/utils/fundinground'
import fundingtype from '@/utils/fundingtype'
import useVuelidate from '@vuelidate/core'
import { helpers, required, url, minValue, minLength } from '@vuelidate/validators'
import { useStore } from 'vuex'
import Helpers from '../../utils/helpers'
import CompanyService from '@/services/company.service'
import store from '@/store'
import StageSevenService from '@/services/stageseven.service'
import DraftService from '../../services/draft.service'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}

export default {
  components: {
    Switch
  },
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    let current = 2
    const route = useRoute()
    const store = useStore()
    const router = useRouter()

    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })

    const selectedIndustry = ref(industries[0])
    const selectedModel = ref(businessmodel[0])
    const selectedRound = ref(fundinground[0])
    const selectedType = ref(fundingtype[0])
    // const progress = reactive({
    //   stage1: true,
    //   stage2: false,
    //   stage3: true
    // })
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })
    const enabled = ref(false)
    const schedule_meeting = ref(false)
    const calenderLoaded = ref(false)
    const loading = ref(false)
    const windowWidth = ref(window.innerWidth)

    // const onWidthChange = () => {
    //   windowWidth.value = window.innerWidth
    // }
    // console.log(windowWidth.value)

    // onMounted(() => {
    //   window.addEventListener('resize', onWidthChange)
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('resize', onWidthChange)
    // })

    const goToStep2 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-16.66%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep1 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '0%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep3 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.32%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep2 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-16.666%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep4 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-49.97%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep3 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.32%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    function isCalendlyEvent (e) {
      return e.data.event && e.data.event.indexOf('calendly') === 0
    }

    const getCalendar = () => {
      const name = store.state.app.company.company_name
      const email = store.state.auth.user.email
      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url: process.env.VUE_APP_CALENDLY_URL,
        parentElement: document.getElementById('calender'),
        prefill: {
          name: name,
          email: email
        },
        utm: {}
      })
    }

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 7')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.target_raise = draft.target_raise
          data.prior_raise = draft.prior_raise
          data.existing_debt = draft.existing_debt
          data.existing_investors = draft.existing_investors
          data.cash_use = draft.cash_use
          data.milestones = draft.milestones
          data.future_funding = draft.future_funding
          data.fundraise_close = draft.fundraise_close
          data.shortterm_needs = draft.shortterm_needs
          data.vesting_provisions = draft.vesting_provisions
          data.fulltime_employee = draft.fulltime_employee
          data.parttime_employee = draft.parttime_employee
          data.employee_agreement = draft.employee_agreement
          data.intrest_conflict = draft.intrest_conflict
          data.likely_exit = draft.likely_exit
          data.likely_acquirers = draft.likely_acquirers
          data.likely_time = draft.likely_time
          data.exit_valuation = draft.exit_valuation
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        target_raise: data.target_raise,
        prior_raise: data.prior_raise,
        existing_debt: data.existing_debt,
        existing_investors: data.existing_investors,
        cash_use: data.cash_use,
        milestones: data.milestones,
        future_funding: data.future_funding,
        fundraise_close: data.fundraise_close,
        shortterm_needs: data.shortterm_needs,
        vesting_provisions: data.vesting_provisions,
        fulltime_employee: data.fulltime_employee,
        parttime_employee: data.parttime_employee,
        employee_agreement: data.employee_agreement,
        intrest_conflict: data.intrest_conflict,
        likely_exit: data.likely_exit,
        likely_acquirers: data.likely_acquirers,
        likely_time: data.likely_time,
        exit_valuation: data.exit_valuation
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 7',
        data: stagedata
      }
      // console.log(draft)
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const data = reactive({
      target_raise: '',
      prior_raise: '',
      existing_debt: 'Yes',
      existing_investors: 'Yes',
      cash_use: [
        {
          data: ''
        }
      ],
      milestones: [
        {
          data: ''
        }
      ],
      future_funding: '',
      fundraise_close: '',

      shortterm_needs: '',
      vesting_provisions: 'Yes',
      fulltime_employee: '',
      parttime_employee: '',
      employee_agreement: 'Yes',
      intrest_conflict: '',

      likely_exit: '',
      likely_acquirers: '',
      likely_time: '',
      exit_valuation: ''
    })
    const rules = computed(() => ({
      target_raise: { required, minLengthValue: minLength(3) },
      prior_raise: { required, minLengthValue: minLength(3) },
      cash_use: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      milestones: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      future_funding: { required, minLengthValue: minLength(3) },
      fundraise_close: { required, minLengthValue: minLength(3) },
      shortterm_needs: { required, minLengthValue: minLength(3) },
      vesting_provisions: { required, minLengthValue: minLength(3) },
      fulltime_employee: {
        required,
        minValueValue: minValue(0)
      },
      parttime_employee: {
        required,
        minValueValue: minValue(0)
      },
      employee_agreement: { required, minLengthValue: minLength(3) },
      intrest_conflict: { required, minLengthValue: minLength(3) },
      likely_exit: { required, minLengthValue: minLength(3) },
      likely_acquirers: { required, minLengthValue: minLength(3) },
      likely_time: { required, minLengthValue: minLength(3) },
      exit_valuation: { required, minLengthValue: minLength(3) }
    }))

    const v$ = useVuelidate(rules, data)

    const addNewField = (arr) => {
      arr.push({
        data: ''
      })
    }
    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }
    const checkValidForm = (v$, screen) => {
      switch (screen) {
        case 'Fundraising':
          if (v$.target_raise.$invalid ||
          v$.prior_raise.$invalid ||
          v$.cash_use.$invalid ||
          v$.milestones.$invalid ||
          v$.future_funding.$invalid ||
          v$.fundraise_close.$invalid) {
            return true
          }
          break
        case 'Team':
          if (v$.shortterm_needs.$invalid ||
          v$.fulltime_employee.$invalid ||
          v$.parttime_employee.$invalid ||
          v$.intrest_conflict.$invalid) {
            return true
          }
          break
        case 'Exit':
          if (v$.likely_exit.$invalid ||
          v$.likely_acquirers.$invalid ||
          v$.likely_time.$invalid ||
          v$.exit_valuation.$invalid) {
            return true
          }
          break
        default:
          return false
      }
    }
    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      const cashUse = Helpers.changeToArray(data.cash_use, 'data')
      const mileStones = Helpers.changeToArray(data.milestones, 'data')

      // eslint-disable-next-line no-unused-vars
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        target_raise: data.target_raise,
        prior_raise: data.prior_raise,
        existing_debt: data.existing_debt,
        existing_investors: data.existing_investors,
        cash_use: cashUse,
        milestones: mileStones,
        future_funding: data.future_funding,
        fundraise_close: data.fundraise_close,
        shortterm_needs: data.shortterm_needs,
        vesting_provisions: data.vesting_provisions,
        fulltime_employee: Number(data.fulltime_employee),
        parttime_employee: Number(data.parttime_employee),
        employee_agreement: data.employee_agreement,
        intrest_conflict: data.intrest_conflict,
        likely_exit: data.likely_exit,
        likely_acquirers: data.likely_acquirers,
        exit_time: data.likely_time,
        exit_valuation: data.exit_valuation
      }

      try {
        const response = await StageSevenService.createStageSeven(stagedata)
        if (response.status === 200 && response.data.status === 'success') {
          loading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)
          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        loading.value = false
        Helpers.processError(e, store, router)
      }
      const success = {
        status: true,
        message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
      }
      store.commit('setSuccess', success)
    }

    onMounted(() => {
      window.addEventListener(
        'message',
        function (e) {
          if (isCalendlyEvent(e)) {
            // console.log(e.data)
            if (e.data.event === 'calendly.event_scheduled') {
              schedule_meeting.value = true
              const calendar = document.getElementById('calender')
              calendar.style.display = 'none'
            } else if (e.data.event === 'calendly.event_type_viewed') {
              calenderLoaded.value = true
            } else {
              calenderLoaded.value = false
              schedule_meeting.value = false
            }
          }
        }
      )
    })

    watch(
      () => enabled.value,
      (value) => {
        if (value === true) {
          getCalendar()
        }
      }

    )

    return {
      route,
      progress: computed(() => store.state.app.progress_status),
      disabled,
      loading,
      industries,
      selectedIndustry,
      businessmodel,
      selectedModel,
      fundinground,
      selectedRound,
      fundingtype,
      selectedType,
      goToStep2,
      returnToStep1,
      goToStep3,
      returnToStep2,
      goToStep4,
      returnToStep3,
      enabled,
      data,
      v$,
      url,
      addNewField,
      removeField,
      checkValidForm,
      isCalendlyEvent,
      calenderLoaded,
      schedule_meeting,
      onSubmit,
      windowWidth,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
.contain .form-outer{
  width: 100%;
  overflow: hidden;
}
.contain .form-outer .forms{
  display: flex;
  width: 600%;
}
.form-outer .forms .page{
  width: 16.66%;
  transition: margin-left 0.3s ease-in-out;
}
.contain .progress-bar{
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 60px 5px;
  user-select: none;
}
.contain .progress-bar .step{
  text-align: center;
  position: relative;
}

.progress-bar .step .bullet{
  height: 16px;
  width: 16px;
  background-color: rgba(229, 230, 230, 1);
  display: flex;
  border-radius: 50%;
  position: relative;
  transition: 0.2s;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.progress-bar .step .bullet.active{
  background-color: #000000;
  height: 20px;
  width: 20px;
}
.progress-bar .step .bullet.active + p{
  color: #000000;
}
.progress-bar .step .bullet.active::after {
  content: "";
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: solid 1px white;
  border-radius: 50%;
  position: absolute;
}
.progress .current-progress{
  display: none;
}
.progress .current-progress.active{
  display: flex;
}
</style>
